<template>
  <div class="sub-page">
    <div class="sub-header" style="background-image: url('/img/mine/login-bg.png'), linear-gradient(90deg, rgb(79, 43, 138), rgb(245, 96, 205));">
      <van-nav-bar :title="$t('my.task_record') || '歷史記錄'" class="sub-nav">
        <template #left>
          <van-icon name="arrow-left" color="#fff" @click="back()"/>
        </template>
      </van-nav-bar>
    </div>

    <div class="sub-body">
      <div class="card form-card">
        <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
          <van-empty v-if="list.length === 0" description="暫無記錄" />
          <div v-else class="game-item van-hairline--bottom" v-for="(v, key) in list" :key="key">
            <div class="game-header">
              <div class="status-badge" :class="v.win > 0 ? 'win' : 'loss'">
                {{ v.win > 0 ? 'Win' : (v.status === 1 ? 'Loss' : 'Loading') }}
              </div>
              <div class="game-info">
                <div class="game-name">{{ lang == 'en' ? v.lottery.name_es : v.lottery.name }}</div>
                <div class="expect">{{ v.expect }}</div>
              </div>
              <div class="win-amount" :class="v.win > 0 ? 'win-text' : 'loss-text'">
                {{ v.win > 0 ? '+' + v.win : v.win }}
              </div>
            </div>

            <div class="game-detail">
              <div class="detail-row">
                <span class="label">{{$t('auth.top2')}}:</span>
                <span class="tag" v-for="(vs, keys) in v.wan" :key="keys">
                  {{ vs.name=='big'?rose:vs.name=='small'?lily:vs.name=='one'?fireworks:balloon }}
                </span>
              </div>
              <div class="detail-row">
                <span class="label">{{$t('auth.top3')}}:</span>
                <span class="tag" v-for="(vs, keys) in v.jie" :key="keys">
                  {{ vs.name=='big'?rose:vs.name=='small'?lily:vs.name=='one'?fireworks:balloon }}
                </span>
              </div>
              <div class="detail-row">
                <span class="label">{{$t('auth.top1')}}: {{v.money}}</span>
              </div>
              <div class="time-info">
                {{$t('reservation.order_time')}}: {{v.create_time}}<br>
                {{$t('reservation.settle_time')}}: {{v.update_time}}
              </div>
            </div>
          </div>
        </van-pull-refresh>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      list: [],
      sum: '',
      double: '',
      fireworks: "情",
      lang: this.$t("auth.lang"),
      size: "",
      rose: "意",
      lily: "亂",
      balloon: "迷"
    };
  },
  methods: {
    back() {
      return window.history.back();
    },
    onRefresh() {
      setTimeout(() => {
        this.getUserGameList();
        this.$toast(this.$t("reservation.refresh"));
        this.isLoading = false;
      }, 500);
    },
    getUserGameList() {
      this.$http({
        method: 'get',
        url: 'user_get_game_list'
      }).then(res => {
        if (res && res.code === 200) {
          this.list = res.data || [];
        } else if (res) {
          this.$toast(res.msg);
        }
      });
    }
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({ path: '/Login' });
    } else {
      this.getUserGameList();
    }
    const lang = this.$t("auth.lang");
    if (lang === 'en') {
      this.rose = 'Rose';
      this.lily = 'Lily';
      this.fireworks = 'Fireworks';
      this.balloon = 'Balloon';
    } else {
      this.rose = '意';
      this.lily = '亂';
      this.fireworks = '情';
      this.balloon = '迷';
    }
  }
};
</script>

<style scoped>
.sub-page {
  width: 100%;
  min-height: 100vh;
  background-color: #f3f3f5;
  padding-bottom: 60px;
  box-sizing: border-box;
  font-family: -apple-system, BlinkMacSystemFont, "PingFang SC", "Helvetica Neue", STHeiti, "Microsoft Yahei", Tahoma, Simsun, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.sub-header {
  position: relative;
  width: 100%;
  height: 220px;
  background-image: url('/img/mine/login-bg.png'), linear-gradient(90deg, rgb(79, 43, 138), rgb(245, 96, 205));
  background-size: 100% auto;
  background-position: center bottom;
  background-repeat: no-repeat;
  box-sizing: border-box;
}

.sub-nav {
  background: transparent !important;
  height: 100px;
}

::v-deep .sub-nav .van-nav-bar__content {
  height: 100px;
}

::v-deep .sub-nav .van-nav-bar__title {
  color: #ffffff !important;
  font-size: 34px !important;
  font-weight: 600 !important;
  line-height: 100px;
}

::v-deep .sub-nav .van-icon {
  color: #ffffff !important;
  font-size: 44px !important;
}

.sub-body {
  padding: 0 30px;
  margin-top: -60px;
  position: relative;
  z-index: 10;
}

.form-card {
  background: #ffffff;
  border-radius: 24px;
  padding: 20px 30px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.05);
}

.game-item {
  padding: 24px 0;
}

.game-header {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}

.status-badge {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  color: #ffffff;
  font-size: 22px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.status-badge.win {
  background: linear-gradient(135deg, #68ec6e, #09953d);
}

.status-badge.loss {
  background: linear-gradient(135deg, #fa6aa5, #f32879);
}

.game-info {
  margin-left: 20px;
  flex: 1;
}

.game-name {
  font-size: 28px;
  font-weight: 600;
  color: #333333;
}

.expect {
  font-size: 24px;
  color: #999999;
  margin-top: 4px;
}

.win-amount {
  font-size: 32px;
  font-weight: 700;
}

.win-text {
  color: #09953d;
}

.loss-text {
  color: #f32879;
}

.game-detail {
  font-size: 24px;
  color: #666666;
  background: #f7f7f9;
  border-radius: 16px;
  padding: 16px 20px;
}

.detail-row {
  margin-bottom: 8px;
  display: flex;
  align-items: center;
}

.detail-row .label {
  font-weight: 600;
  color: #333333;
  margin-right: 10px;
}

.detail-row .tag {
  background: linear-gradient(90deg, #f560cd, #4f2b8a);
  color: #ffffff;
  padding: 2px 12px;
  border-radius: 12px;
  font-size: 22px;
  margin-right: 6px;
}

.time-info {
  font-size: 22px;
  color: #999999;
  line-height: 1.4;
  margin-top: 10px;
}
</style>
